module.exports = __webpack_public_path__ + "static/media/placeholderapp.a38f8e62.svg";